import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { JourneyFab } from "./JourneyFab";
import { JourneyAssessment } from "./JourneyAssessment";
import { JourneyProvider } from "../context/JourneyContext";

let lenisInstance = null;

export const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    lenisInstance = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);

  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const scroll = () => {
        const el = document.querySelector(hash);
        if (!el) return;
        if (lenisInstance) lenisInstance.scrollTo(el, { offset: -60 });
        else el.scrollIntoView({ behavior: "smooth" });
      };
      const t = setTimeout(scroll, 200);
      return () => clearTimeout(t);
    }
    if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <JourneyProvider>
      <div className="App min-h-screen bg-navy">
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: { background: "#08172D", color: "#F7F3EB", border: "1px solid rgba(212,175,103,0.3)" },
          }}
        />
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
        <JourneyFab />
        <JourneyAssessment />
      </div>
    </JourneyProvider>
  );
};
